export default `
  mutation createChatLog($projectId: ID!, $input: ChatLogInput!) {
    createChatLog(projectId: $projectId, input: $input) {
      id
      workflowId
      type
      content
      userId
      aiOutput
      workflowVersion
      createdAt
    }
  }
`
